"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class STATE {
}
STATE.ON = true;
STATE.YES = true;
STATE.OFF = false;
STATE.NO = false;
exports.STATE = STATE;
class A {
}
A.TRANSPARENT_ITEM = 'transitem';
A.TRANSPARENT_TERRAIN = 'transterrain';
A.POINTCLOUD = 'pointcloud';
A.TERRAIN = 'terrain';
exports.A = A;
class IS {
}
IS.TRANSPARENT = 'transparent';
IS.COLORIZED = 'colorized';
exports.IS = IS;
class TURN {
}
TURN.ON = true;
TURN.OFF = false;
exports.TURN = TURN;
